import React from "react";

// Assets
import line from "../../Assets/lines.svg";
import youtube from "../../Assets/youtubelogo.svg";
import inlogo from "../../Assets/in.svg";
import insta from "../../Assets/insta.svg";
import fb from "../../Assets/fb.svg";

import android from "../../Assets/android.svg";
import apple from "../../Assets/apple.svg";
import ios from "../../Assets/ios.svg";
import linux from "../../Assets/linux.svg";
import steam from "../../Assets/steam.svg";
import unreal from "../../Assets/unreal.svg";
import windows from "../../Assets/windows.svg";
import xbox from "../../Assets/xbox.svg";

function ServicesSection() {
  return (
    <div className="servicesSection">
      <div className="servicesSection_cards">
        <div class="servicesSection_card1">
          <div class="content">
            <div>Games</div>
            <div>Concept to commercialization</div>
            <div>All the resources you need to create, launch and succeed with Mobile, Instant, Console/PC, and AR/VR games.</div>
          </div>
          <div class="flap"></div>
        </div>
        <div class="servicesSection_card1">
          <div class="content">
            <div>Animation</div>
            <div>Faster, better creative storytelling</div>
            <div>When you can render frames in fractions of seconds, the ability to produce content much, much faster.</div>
          </div>
          <div class="flap"></div>
        </div>
        <div class="servicesSection_card1">
          <div class="content">
            <div>Architecture</div>
            <div>Accelerating innovation </div>
            <div>Create immersive, interactive experiences for VR, AR, and mobile that win deals, streamline your workflows, and lower costs.</div>
          </div>
          <div class="flap"></div>
        </div>
        <div class="servicesSection_card1">
          <div class="content">
            <div>Film & Cinematics</div>
            <div>Next-level virtual production toolset</div>
            <div>From high-quality visualization that accurately communicates creative intent, to action sequences and VFX.</div>
          </div>
          <div class="flap"></div>
        </div>
        <div className="bgimg"></div>
      </div>
      <div className="servicesSection_clients">
        <div className="servicesSection_top">
          <div className="servicesSection_title">Deliver incredible possibilities</div>
          <div className="servicesSection_description">Create once, deploy across 25+ leading platforms and technologies to reach the largest possible audience.</div>
        </div>
        <marquee behavior="scroll" direction="left">
          <img src={apple} alt="3D Model" />
          <img src={windows} alt="3D Model" />
          <img src={linux} alt="3D Model" />
          <img src={android} alt="3D Model" />
          <img src={steam} alt="3D Model" />
          <img src={xbox} alt="3D Model" />
          <img src={unreal} alt="3D Model" />
          <img src={ios} alt="3D Model" />
          <div className="servicesSection_maquree">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </marquee>
      </div>

      <div className="socialinks">
        <div>
          <img src={youtube} alt="3D Model" />
        </div>
        <div>
          <img src={fb} alt="3D Model" />
        </div>
        <div>
          <img src={insta} alt="3D Model" />
        </div>
        <div>
          <img src={inlogo} alt="3D Model" />
        </div>
      </div>

      <div className="line">
        <img src={line} alt="3D Model" />
      </div>
    </div>
  );
}

export default ServicesSection;
